export enum TutorXslxHeaders {
    NAME = "name",
    PHONE_NUMBER = "phone_number",
    EMAIL = "email",
    PASSWORD = "password",
    BRANCH_ID = "branch_id",
    CLASS_TEACHER = "class_teacher",
    SECTION_SUBJECTS = "section_subjects"
}